import {
  ActivityIcon,
  BookOpenIcon,
  CalendarDaysIcon,
  DumbbellIcon,
  HeartPulseIcon,
  type LucideIcon,
} from 'lucide-react'

export type CourseModule = {
  icon: LucideIcon
  kicker: string
  title: string
  description: string
  features: string
  accent: string
}

export const modules: CourseModule[] = [
  {
    icon: BookOpenIcon,
    kicker: 'Volumes 01–02',
    title: 'Annual Movement Foundations & Programming',
    description:
      'A comprehensive roadmap for beginner and intermediate functional athletes, built around mechanics and progression.',
    features: 'Biometrics · Fundamentals · Linear Progressions',
    accent: 'bg-sage-600',
  },
  {
    icon: DumbbellIcon,
    kicker: 'Volume 03',
    title: 'Strength, Power & Explosive Performance',
    description:
      'Advanced sequences designed for force production and athletic conditioning, with clean transitions between blocks.',
    features: 'Strength · Rate of Force · Transitions',
    accent: 'bg-clay-500',
  },
  {
    icon: ActivityIcon,
    kicker: 'Volume 04',
    title: 'Functional Tools Mastery',
    description:
      'Creative programming that integrates equipment to eliminate plateaus and keep clients engaged session after session.',
    features: 'Kettlebells · Resistance Bands · Med Balls',
    accent: 'bg-ink-700',
  },
  {
    icon: HeartPulseIcon,
    kicker: 'Volume 05',
    title: 'Clinical Protocols & Spine Health',
    description:
      'Coach with confidence. Exactly how to handle clients with back pain or disc issues inside a functional context.',
    features: 'Stability · Safety · Risk Mitigation',
    accent: 'bg-sage-700',
  },
  {
    icon: CalendarDaysIcon,
    kicker: 'Volume 06',
    title: 'Special Populations & Pre-Natal Fitness',
    description:
      'Ready-made plans for senior and pre-natal clients so you can expand your market share safely.',
    features: 'Longevity · Pre-Natal · Senior Strength',
    accent: 'bg-clay-600',
  },
]
